export default {
  sequencia: {
    value: null,
    required: false,
    state: null
  },
  descricao: {
    value: null,
    required: true,
    state: null
  },
  unidade: {
    value: null,
    required: false,
    state: null
  },
  valor: {
    value: null,
    required: true,
    state: null
  },
  quantidade: {
    value: null,
    required: true,
    state: null
  },
  codigoCliente: {
    value: null,
    required: false,
    state: null
  },
  descricaoCliente: {
    value: null,
    required: false,
    state: null
  },
  observacao: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/tecanalysis/additive-form.js